import classNames from "classnames"
import React, { useState, ChangeEvent } from "react"
import style from "./index.module.css"
import Typography from "../Typography"

export interface CustomFileInputProps {
  className?: string
  label?: string
  name: string
  placeholder?: string
  inputRef?: React.Ref<any>
  acceptedFiles?: string
}

const CustomFileInput = ({
  className,
  label,
  placeholder,
  name,
  inputRef,
  acceptedFiles,
}: CustomFileInputProps) => {
  const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined)

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    setSelectedFile(file)
  }

  return (
    <div className={classNames(style.fileInputContainer)}>
      <input
        type="file"
        className={classNames(className, style.customFileInput)}
        placeholder={placeholder ? placeholder : label}
        name={name}
        ref={inputRef}
        onChange={handleFileChange}
        accept={acceptedFiles}
      />
      <Typography variant="subtitle1" color="black" underline>
        Carica un file
      </Typography>
      <span className={classNames(style.fileInputLabel)}>
        {selectedFile ? selectedFile.name : "Nessun file selezionato"}
      </span>
    </div>
  )
}

export default CustomFileInput
